import HomePage from 'admin-app/home';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Provider } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';

import adminStore from './redux/admin.store';
import { adminStoreContext } from 'admin-app/redux/admin.store';

function AdminApp() {
  return (
    <Provider store={adminStore} context={adminStoreContext}>
      <HomePage />
    </Provider>
  );
}

export default AdminApp;
